// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Link } from 'react-router';
import { TopbarUserMenu } from './topbar-user-menu';
import { AppIcon } from '@shared/ui-kit';
import { SwitchCurrency } from './switch-currency';
import { LanguageSelector } from '@shared/ui-kit/components/language-selector';

interface TopbarProps {
  onOpenSidebar?: () => void;
}

export const Topbar = ({ onOpenSidebar }: TopbarProps) => {
  return (
    <div
      data-testid="topbar"
      className="sticky top-0 z-20 flex w-full bg-page px-4 py-6 lg:px-8 lg:py-8 xl:px-16 xl:py-10"
    >
      <div
        className="flex min-w-0 flex-1 items-center justify-between gap-2 xl:justify-end xl:gap-4"
        data-testid="topbar-search"
      >
        {onOpenSidebar ? (
          <button
            type="button"
            className="flex shrink-0 items-center justify-center rounded-lg p-2 text-title-alt xl:hidden"
            onClick={onOpenSidebar}
            data-testid="topbar-menu-button"
            aria-label="Open navigation menu"
          >
            <AppIcon icon="Menu" size="xl" color="main" />
          </button>
        ) : null}

        <div className="hidden items-center gap-2 xl:flex xl:gap-4">
          <SwitchCurrency />
          <div className="text-title-alt">
            <LanguageSelector />
          </div>
          <nav className="border-r-0 pr-2 lg:pr-4">
            <Link to="/">
              <AppIcon
                icon="Home"
                className="text-control-track"
                size="xl"
                data-testid="app-icon"
              />
            </Link>
          </nav>
        </div>

        <TopbarUserMenu />
      </div>
    </div>
  );
};
